import { useContext } from "react";
import { TimerContext } from "../context/TimerContext";

function useTimer() {
  return useContext(TimerContext);
};

export default useTimer;
